import LimitedAdaptiveEquipment from './LimitedAdaptiveEquipment';

export default LimitedAdaptiveEquipment;
